import { updateDriverComment } from "../../data/repository/driverCommentRepo";

export const updateDriverCommentUseCase = async (driverComment) => {
  return await updateDriverComment(driverComment);
};
